import { render, staticRenderFns } from "./secondStepSelfAccount.vue?vue&type=template&id=39712bd2&scoped=true"
import script from "./secondStepSelfAccount.vue?vue&type=script&lang=js"
export * from "./secondStepSelfAccount.vue?vue&type=script&lang=js"
import style0 from "./secondStepSelfAccount.vue?vue&type=style&index=0&id=39712bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39712bd2",
  null
  
)

export default component.exports